// Single source of truth for the provider brand. Replace these values to
// re-skin the whole lobby; nothing else needs to change. The server may also
// return a brand via /api/config, which (when present) overrides these.

export interface BrandConfig {
  name: string;
  tagline: string;
  logoText: string;
}

export const BRAND: BrandConfig = {
  name: 'AeroPlay Studios',
  tagline: 'Game provider technology showcase',
  logoText: 'AeroPlay',
};
